/**
 * The only formatting the bot's replies get: **bold**.
 *
 * Built with DOM nodes, never innerHTML — the reply is model output, and
 * treating it as HTML would let a crafted answer inject markup into the
 * customer's page. Anything else stays plain text (line breaks are kept by
 * `white-space: pre-wrap`).
 */
export function appendRichText(parent, text) {
  const parts = String(text).split(/(\*\*[^*\n]+\*\*)/g);
  for (const part of parts) {
    if (part.length > 4 && part.startsWith('**') && part.endsWith('**')) {
      const strong = parent.ownerDocument.createElement('strong');
      strong.textContent = part.slice(2, -2);
      parent.appendChild(strong);
    }
    else if (part) {
      parent.appendChild(parent.ownerDocument.createTextNode(part));
    }
  }
  return parent;
}
